// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload[data-v-50874b78] {\n  display: flex;\n}\n.upload[data-v-50874b78]  .el-upload {\n  order: 2;\n}\n.upload[data-v-50874b78]  .el-upload-list {\n  order: 1;\n  width: 100%;\n  margin-right: 1em;\n}\n.upload[data-v-50874b78]  .el-upload-list .el-upload-list__item {\n  margin-top: 0;\n}", ""]);
// Exports
module.exports = exports;
